import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const propTypes = {
    title : PropTypes.string.isRequired, 
    text : PropTypes.string.isRequired
}

const AbbrComponent = ({
    title, text
}) => {
    return (
        <abbr title={title}>{text}</abbr>
    )
}

AbbrComponent.propTypes = propTypes;

const Abbr = styled(AbbrComponent)``

export default Abbr;